import React from 'react';
import styles from './Loader.module.css';
import { useSelector } from 'react-redux';
import { IInitialState } from '../../../types/initialState.types';

/**
 * Loader
 *
 * @description DoSelect Loader
 * @returns {React.JSX.Element}
 *
 * @example
 *
 * In saga:
 * ```javascript
 * yield put({
 *  type: SHOW_LOADER,
 *  payload: {
 *    show: true,
 *  },
 * });
 *```
 *
 * */

const Loader: React.FC = (): React.JSX.Element => {
  const { message } = useSelector((state: IInitialState) => state.loader);

  return (
    <div className={styles.loaderWrapper}>
      <div className={styles.beatLoader}>
        <div className={styles.beat}></div>
        <div className={styles.beat}></div>
        <div className={styles.beat}></div>
      </div>
      {message && <div className={styles.message}>{message}</div>}
    </div>
  );
};

export default Loader;
